import React, { useState, useEffect, useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import "react-phone-input-2/lib/style.css";
import Button from "react-bootstrap/Button";
import { useLocation, useNavigate } from "react-router-dom";
import LoginBg from "../../images/newimg/login.jpg";
import Image from "react-bootstrap/Image";
import SuccessIcon from "../../images/pending.svg";
import Modal from "react-bootstrap/Modal";
import { LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { toast } from "react-toastify";
import ApiService from "../../../utility/services/ApiService";
import { AuthContext } from "../../../utility/services/AuthContext";
import Functions from "../../../utility/services/Functions";
import ConstConfig from "../../../utility/configs/constConfig";
import { MultiSelect } from "react-multi-select-component";
import { ValidationsService } from "../../../utility/services/ValidationsService";
import { trackScreenView, trackButtonClick, trackEvent } from "../../../utility/services/analyticsService";

const StartTime = new Date(new Date().setHours(9, 0, 0, 0)).toUTCString();
const EndTime = new Date(new Date().setHours(18, 0, 0, 0)).toUTCString();

const min_thirty_min_amt = 39;
const min_sixty_min_amt = 59;
const daysArr = [
  {
    id: 1,
    checked: false,
    day: "Mon",
    start_time: "",
    end_time: "",
  },
  {
    id: 2,
    checked: false,
    day: "Tue",
    start_time: "",
    end_time: "",
  },
  {
    id: 3,
    checked: false,
    day: "Wed",
    start_time: "",
    end_time: "",
  },
  {
    id: 4,
    checked: false,
    day: "Thu",
    start_time: "",
    end_time: "",
  },
  {
    id: 5,
    checked: false,
    day: "Fri",
    start_time: "",
    end_time: "",
  },
  {
    id: 6,
    checked: false,
    day: "Sat",
    start_time: "",
    end_time: "",
  },
  {
    id: 7,
    checked: false,
    day: "Sun",
    start_time: "",
    end_time: "",
  },
];

const priceArr = [
  { id: 1, checked: false, time_in_min: "30", price: min_thirty_min_amt },
  { id: 2, checked: false, time_in_min: "60", price: min_sixty_min_amt },
];

function MyVerticallyCenteredModal(props) {
  const { navigate } = props;
  return (
    <Modal
      {...props}
      size="sm"
      className="modalSuccess"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Image src={SuccessIcon} alt="" />
        <h4>Approval Pending</h4>
        <p>
          Your account has been created, We will check your details and let you
          know the status of your account shortly.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.replace("/");
          }}
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const TherapistCompleteProfile = () => {
  // LOGICAL VARIABLES

  const [modalShow, setModalShow] = React.useState(false);
  const { get_licence_list, get_language_list, submit_profile } = ApiService();
  const { setLoading } = useContext(AuthContext);
  const { consoleService, adjustSecondTimestamp } = Functions();
  const [validationsRes, setValidationsRes] = useState({});

  const [certificateList, setLicenceList] = useState([]);
  const [languageLIst, setLanguageList] = useState([]);

  const [submit, setSubmit] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const priceInputRefs = useRef([]);

  // DATA VARIABLES

  const userId = location.state != null ? location.state : "";
  const [bio, setBio] = useState("");
  const [daysArray, setDaysArray] = useState([...daysArr]);
  const [pricingArr, setPricingArr] = useState([...priceArr]);
  const [language, setLanguage] = useState([]);
  const [licence, setLicence] = useState([]);

  const findThirtyMinEntry = pricingArr.findIndex(
    (item) => item.time_in_min == 30
  );
  const findSixtyMinEntry = pricingArr.findIndex(
    (item) => item.time_in_min == 60
  );
  const ThirtyMinCond =
    pricingArr[findThirtyMinEntry].price >= min_thirty_min_amt;
  const SixtyMinCond = pricingArr[findSixtyMinEntry].price >= min_sixty_min_amt;

  // USE EFFECTS

  useEffect(() => {
    trackScreenView("complete_profile_screen", { screen_name: "Complete Profile", user_type: "therapist_user" });
    fetch_lists();
  }, []);

  useEffect(() => {
    validationsResFun();
  }, [licence, language, daysArray, pricingArr, bio]);

  // FUNCTIONS

  function validationsResFun() {
    setValidationsRes(
      ValidationsService({
        licence,
        language,
        availability: daysArray,
        pricing: pricingArr,
        bio,
      })
    );
  }

  async function fetch_lists() {
    setLoading(true);
    try {
      const res = await get_licence_list();
      const language_res = await get_language_list();
      if (res.status === 1 && language_res.status === 1) {
        const modifiedRes = res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        const modifiedLanguageRes = language_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        setLicenceList([...modifiedRes]);
        setLanguageList([...modifiedLanguageRes]);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch lists function = ", err);
    }
  }

  const setStartTimeFun = (id, time) => {
    const Time = new Date(time);
    const newArray = daysArray.map((item) => {
      if (item.id == id) {
        item.start_time = Time.toUTCString();
        return item;
      } else {
        return item;
      }
    });
    setDaysArray([...newArray]);
  };

  const setEndTimeFun = (id, time) => {
    const Time = new Date(time);
    const newArray = daysArray.map((item) => {
      if (item.id == id) {
        item.end_time = Time.toUTCString();
        return item;
      } else {
        return item;
      }
    });
    setDaysArray([...newArray]);
  };

  const check_uncheck_fun = (id) => {
    const check = daysArray.some((item) => {
      return item.id == id && item.checked == false;
    });

    const findEntry = daysArray.find((item) => item.id == id);

    if (check) {
      const startTime = new Date(findEntry.start_time);
      const end_time = new Date(findEntry.end_time);
      const time1 = startTime.getHours() * 60 + startTime.getMinutes();
      const time2 = end_time.getHours() * 60 + end_time.getMinutes();
      const condition = time1 < time2;
      if (!findEntry.start_time || !findEntry.end_time) {
        const newArray = daysArray.map((item) => {
          if (item.id == id) {
            item.checked = check;
            if (!item.start_time) {
              item.start_time = StartTime;
            }
            if (!item.end_time) {
              item.end_time = EndTime;
            }
            return item;
          } else {
            return item;
          }
        });
        setDaysArray([...newArray]);
      } else {
        if (condition) {
          const newArray = daysArray.map((item) => {
            if (item.id == id) {
              item.checked = check;
              return item;
            } else {
              return item;
            }
          });
          setDaysArray([...newArray]);
        } else {
          toast("Incorrect time schedule.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }
    } else {
      const newArray = daysArray.map((item) => {
        if (item.id == id) {
          item.start_time = "";
          item.end_time = "";
          item.checked = check;
          return item;
        } else {
          return item;
        }
      });
      setDaysArray([...newArray]);
    }
  };

  const setTimeValueFun = (id, value) => {
    const newArray = pricingArr.map((item) => {
      if (item.id == id) {
        item.price = value.toString();
        return item;
      } else {
        return item;
      }
    });
    setPricingArr([...newArray]);
  };

  const MInCond_toast = (amt) => {
    toast(`Price should be minimum ${amt}.`, {
      position: "top-center",
      hideProgressBar: true,
      type: "error",
    });
  };

  const check_uncheck_pricing_fun = (id, index) => {
    const check = pricingArr.some((item) => {
      return item.id == id && item.checked == false;
    });
    const condition = pricingArr.some((item) => {
      return item.id == id && item.price != "" && Number(item.price) > 0;
    });
    if (check) {
      if (condition) {
        if (index == findThirtyMinEntry && !ThirtyMinCond) {
          MInCond_toast(min_thirty_min_amt);
          return;
        } else if (index == findSixtyMinEntry && !SixtyMinCond) {
          MInCond_toast(min_sixty_min_amt);
          return;
        }
        const newArray = pricingArr.map((item) => {
          if (item.id == id) {
            item.checked = check;
            return item;
          } else {
            return item;
          }
        });
        setPricingArr([...newArray]);
      } else {
        if (index == findThirtyMinEntry) {
          const newArray = pricingArr.map((item) => {
            if (item.id == id) {
              item.checked = check;
              item.price = min_thirty_min_amt;
              return item;
            } else {
              return item;
            }
          });
          setPricingArr([...newArray]);
        } else if (index == findSixtyMinEntry) {
          const newArray = pricingArr.map((item) => {
            if (item.id == id) {
              item.checked = check;
              item.price = min_sixty_min_amt;
              return item;
            } else {
              return item;
            }
          });
          setPricingArr([...newArray]);
        }
      }
    } else {
      const newArray = pricingArr.map((item) => {
        if (item.id == id) {
          item.checked = check;
          return item;
        } else {
          return item;
        }
      });
      setPricingArr([...newArray]);
    }
  };

  function checkAvailability() {
    let errorDay = "";
    const condition = daysArray.some((findEntry) => {
      if (
        findEntry.checked &&
        findEntry.start_time != "" &&
        findEntry.end_time != ""
      ) {
        const startTime = new Date(findEntry.start_time);
        const end_time = new Date(findEntry.end_time);
        const time1 = startTime.getHours() * 60 + startTime.getMinutes();
        const time2 = end_time.getHours() * 60 + end_time.getMinutes();
        const condition = time1 < time2;
        if (!condition) {
          errorDay = findEntry.day;
        }
        return !condition;
      } else {
        return false;
      }
    });

    const isAvailabilityOK = !condition;

    return { isAvailabilityOK, errorDay };
  }

  const submitFun = async () => {
    trackButtonClick("complete_profile_cta", { button_name: "Submit", screen_name: "Complete Profile" });
    setSubmit(true);
    if (
      !validationsRes.licenceErr &&
      !validationsRes.availabilityErr &&
      !validationsRes.languageErr &&
      !validationsRes.bioErr &&
      !validationsRes.pricingErr
    ) {
      const { isAvailabilityOK, errorDay } = checkAvailability();
      let Day = "";
      switch (errorDay) {
        case "Mon":
          Day = "Monday";
          break;
        case "Tue":
          Day = "Tuesday";
          break;
        case "Wed":
          Day = "Wednesday";
          break;
        case "Thu":
          Day = "Thursday";
          break;
        case "Fri":
          Day = "Friday";
          break;
        case "Sat":
          Day = "Saturday";
          break;
        case "Sun":
          Day = "Sunday";
          break;
      }
      if (!isAvailabilityOK)
        return toast("Invaild entry found on " + Day, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      if (
        (pricingArr[findThirtyMinEntry].checked && !ThirtyMinCond) ||
        (pricingArr[findSixtyMinEntry].checked && !SixtyMinCond)
      ) {
        return pricingArr[findThirtyMinEntry].checked && !ThirtyMinCond
          ? MInCond_toast(min_thirty_min_amt)
          : MInCond_toast(min_sixty_min_amt);
      }
      setLoading(true);
      try {
        const resolvedSecondStampsDaysArr = daysArray.map((obj) => {
          const firstStamp = obj.start_time;
          const secondStamp = obj.end_time;
          if (obj.checked) {
            const newObj = obj;
            newObj.start_time = adjustSecondTimestamp(
              firstStamp,
              secondStamp
            ).firstDate;
            newObj.end_time = adjustSecondTimestamp(
              firstStamp,
              secondStamp
            ).secondDate;
            return newObj;
          } else {
            return obj;
          }
        });
        const final_availability = resolvedSecondStampsDaysArr.map((item) => {
          if (item.checked) {
            return item;
          } else {
            item.start_time = "";
            item.end_time = "";
            return item;
          }
        });
        const data = {
          user_id: userId,
          bio,
          certificates: licence.map((item) => item.value),
          language: language.map((item) => item.value),
          availability: final_availability,
          pricing: pricingArr,
          device_token: "",
          time_zone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        const res = await submit_profile(data);
        if (res.status === 1) {
          trackEvent("profile_submitted", { event_type: "event", screen_name: "Complete Profile" });
          setLoading(false);
          setSubmit(false);
          setModalShow(true);
        } else {
          setLoading(false);
          toast(res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      } catch (err) {
        setLoading(false);
        consoleService("Error in submit function = ", err);
      }
    } else {
      toast("Some fields are missing.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    }
  };

  const handleBlurOfPriceInput = (item, index) => {
    if (
      item.time_in_min == 30 &&
      item.checked &&
      priceInputRefs.current[index].value < min_thirty_min_amt
    ) {
      MInCond_toast(min_thirty_min_amt);
      priceInputRefs.current[index].focus();
    } else if (
      item.time_in_min == 60 &&
      item.checked &&
      priceInputRefs.current[index].value < min_sixty_min_amt
    ) {
      MInCond_toast(min_sixty_min_amt);
      priceInputRefs.current[index].focus();
    }
  };

  // MAIN RETURN
  return (
    <section className="loginBg" style={{ backgroundImage: `url(${LoginBg})` }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Form>
              <div className="loginBox loginUpdateBox">
                <Form.Control
                  as="textarea"
                  style={{
                    height: "auto",
                  }}
                  rows={3}
                  type="text"
                  placeholder="Enter Your Bio"
                  onChange={(e) => {
                    setBio(e.target.value);
                  }}
                />
                {submit && validationsRes.bioErr && (
                  <span
                    className="validations_err"
                    style={{ position: "relative", top: -10 }}
                  >
                    {validationsRes.bioErr}
                  </span>
                )}
                <Form.Group className="mb-3 posUP">
                  <Form.Label className="mb-2">Select License Types</Form.Label>

                  <MultiSelect
                    options={certificateList}
                    value={licence}
                    onChange={setLicence}
                    className="checkBoxNew"
                    labelledBy="Select License Types"
                  />
                  {submit && validationsRes.licenceErr && (
                    <span
                      className="validations_err"
                      style={{ position: "relative", top: 10 }}
                    >
                      {validationsRes.licenceErr}
                    </span>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Select Language</Form.Label>
                  <MultiSelect
                    options={languageLIst}
                    value={language}
                    className="checkBoxNew"
                    onChange={setLanguage}
                    labelledBy="Select Language"
                  />
                  {submit && validationsRes.languageErr && (
                    <span
                      className="validations_err"
                      style={{ position: "relative", top: 10 }}
                    >
                      {validationsRes.languageErr}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="mb-3">
                    Set Your Availability
                  </Form.Label>
                  {daysArray.map((item, index) => {
                    return (
                      <div key={index} className="listItem">
                        <Form.Check
                          aria-label="option 1"
                          checked={item.checked}
                          onClick={() => {
                            check_uncheck_fun(item.id);
                          }}
                        />
                        <span
                          className="days"
                          style={{
                            backgroundColor: item.checked ? "" : "gray",
                          }}
                        >
                          {item.day}
                        </span>
                        <span className="from">From</span>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            label={!item.start_time && "Start Time"}
                            value={
                              item.start_time ? dayjs(item.start_time) : null
                            }
                            onChange={(newValue) => {
                              setStartTimeFun(item.id, newValue.$d);
                            }}
                          />
                        </LocalizationProvider>

                        <span className="from">To</span>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            label={!item.end_time && "End Time"}
                            value={item.end_time ? dayjs(item.end_time) : null}
                            onChange={(newValue) =>
                              setEndTimeFun(item.id, newValue.$d)
                            }
                          />
                        </LocalizationProvider>
                      </div>
                    );
                  })}
                </Form.Group>
                {submit && validationsRes.availabilityErr && (
                  <span
                    className="validations_err"
                    style={{ position: "relative", top: -10 }}
                  >
                    {validationsRes.availabilityErr}
                  </span>
                )}
                <Form.Group className="mb-4">
                  <Form.Label className="mb-3">Set Pricing</Form.Label>
                  {pricingArr.map((item, index) => {
                    return (
                      <div key={index} className="listItem listItem_price">
                        <Form.Check
                          aria-label="option 1"
                          checked={item.checked}
                          onClick={() => {
                            check_uncheck_pricing_fun(item.id, index);
                          }}
                        />
                        <Form.Control
                          type="text"
                          placeholder={`${item.time_in_min} mins`}
                          disabled
                        />
                        <span className="from">Price</span>
                        <div className="price">
                          <span>$</span>
                          <Form.Control
                            ref={(ele) => {
                              priceInputRefs.current[index] = ele;
                            }}
                            type="text"
                            placeholder="0"
                            value={item.price}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                              setTimeValueFun(item.id, numericValue);
                            }}
                            // onBlur={() => {
                            //   handleBlurOfPriceInput(item, index);
                            // }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </Form.Group>
                {submit && validationsRes.pricingErr && (
                  <span
                    className="validations_err"
                    style={{ position: "relative", top: -10 }}
                  >
                    {validationsRes.pricingErr}
                  </span>
                )}

                <Button
                  onClick={() => {
                    submitFun();
                  }}
                  className="btn btn-primary me-3"
                >
                  Submit
                </Button>
              </div>
            </Form>
            <MyVerticallyCenteredModal
              navigate={navigate}
              show={modalShow}
              onHide={() => {
                setModalShow(false);

                window.location.replace("/");
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TherapistCompleteProfile;
